export default __webpack_public_path__ + "static/media/nv_banner_img2.8cf840f1.png";